import { applyTimezone, parseDate } from './../helpers/date';

export class CreditEngineProposal {
  employeeId: string;
  amount: number;
  startDate: Date;
  firstDueDate: Date;
  numberOfInstallments: number;
  period?: number;
  installmentAmount: number;
  interestRate: number;
  effectiveInterestRate: number;
  feeAmount: number;
  taxAmount: number;
  fixedTaxRate: number;
  referencePeriod: string;
  totalFinancedAmount: number;
  totalDebtAmount: number;

  constructor(data: CreditEngineProposal | DjangoCreditEngineProposal = {}) {
    if (data instanceof CreditEngineProposal) {
      bindCreditEngineProposalData(this, data);
    } else {
      bindDjangoCreditEngineProposalData(this, data);
    }
  }
}

export function parseCreditEngineProposal(
  data?: CreditEngineProposal | DjangoCreditEngineProposal,
) {
  if (data) {
    return new CreditEngineProposal(data);
  } else {
    return undefined;
  }
}

///////////////////
// DJANGO SUPPOT //
///////////////////
export interface DjangoCreditEngineProposal {
  employee_id?: string;
  amount?: number;
  start_date?: Date;
  first_due_date?: Date;
  number_of_installments?: number;
  period?: number;
  installment_amount?: number;
  interest_rate?: number;
  effective_interest_rate?: number;
  fee_amount?: number;
  tax_amount?: number;
  fixed_tax_rate?: number;
  reference_period?: string;
  total_financed_amount?: number;
  total_debt_amount?: number;
}

function bindCreditEngineProposalData(
  creditEngineProposal: CreditEngineProposal,
  data: CreditEngineProposal,
) {
  creditEngineProposal.employeeId = data.employeeId;
  creditEngineProposal.amount = data.amount;
  creditEngineProposal.startDate = data.startDate;
  creditEngineProposal.firstDueDate = data.firstDueDate;
  creditEngineProposal.numberOfInstallments = data.numberOfInstallments;
  creditEngineProposal.installmentAmount = data.installmentAmount;
  creditEngineProposal.period = data.period;
  creditEngineProposal.interestRate = data.interestRate;
  creditEngineProposal.effectiveInterestRate = data.effectiveInterestRate;
  creditEngineProposal.feeAmount = data.feeAmount;
  creditEngineProposal.taxAmount = data.taxAmount;
  creditEngineProposal.fixedTaxRate = data.fixedTaxRate;
  creditEngineProposal.referencePeriod = data.referencePeriod;
  creditEngineProposal.totalFinancedAmount = data.totalFinancedAmount;
  creditEngineProposal.totalDebtAmount = data.totalDebtAmount;
}

function bindDjangoCreditEngineProposalData(
  creditEngineProposal: CreditEngineProposal,
  data: DjangoCreditEngineProposal,
) {
  creditEngineProposal.employeeId = data.employee_id;
  creditEngineProposal.amount = data.amount;
  creditEngineProposal.startDate = applyTimezone(parseDate(data.start_date), 0);
  creditEngineProposal.firstDueDate = applyTimezone(parseDate(data.first_due_date), 0);
  creditEngineProposal.numberOfInstallments = data.number_of_installments;
  creditEngineProposal.period = data.period;
  creditEngineProposal.installmentAmount = data.installment_amount;
  creditEngineProposal.interestRate = data.interest_rate;
  creditEngineProposal.effectiveInterestRate = data.effective_interest_rate;
  creditEngineProposal.feeAmount = data.fee_amount;
  creditEngineProposal.taxAmount = data.tax_amount;
  creditEngineProposal.fixedTaxRate = data.fixed_tax_rate;
  creditEngineProposal.referencePeriod = data.reference_period;
  creditEngineProposal.totalFinancedAmount = data.total_financed_amount;
  creditEngineProposal.totalDebtAmount = data.total_debt_amount;
}
